export default __webpack_public_path__ + "static/media/khaf-smart-sec2.f30dd5a8.jpg";